import { render, staticRenderFns } from "./CmgPersonIconWithBadge.vue?vue&type=template&id=200b1cb3&scoped=true&lang=pug"
import script from "./cmg-person-icon-with-badge.ts?vue&type=script&lang=ts&external"
export * from "./cmg-person-icon-with-badge.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPersonIconWithBadge.vue?vue&type=style&index=0&id=200b1cb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200b1cb3",
  null
  
)

export default component.exports